import React from "react";
import { modal, FormBody, FormActions } from "@mc/mc-legacy";
import { i18n } from "../i18n/i18n";

/**
 * Zobrazí informativní dialog s titulkem a textem
 * @param title
 * @param message
 * @param onClose on close callback
 * @param cards jedná se o info dialog s kartičkami, implicitně false
 * @param cancelButton
 * @param modalProps viz metoda show
 * @param lang jazyk
 */
export function showInfo(title, message, onClose, cards = false, cancelButton = true, modalProps = {}, lang = null) {
  return (dispatch) => {
    const useModalProps = {
      ...modalProps,
      onClose,
    };

    dispatch(modal.ModalActions.show(infoDialog(message, dispatch, onClose, cards, lang, cancelButton), null, title, useModalProps));
  };
}

const getRenderableElement = (element) => {
  if (typeof element === "string" || React.isValidElement(element)) {
    return element;
  } else {
    return React.createElement(element);
  }
};

/**
 * Informativní dialog s titulkem a textem
 * @param message
 * @param dispatch
 * @param onClose on close callback
 * @param cards jedná se o info dialog s kartičkami, implicitně false
 * @param lang jazyk
 * @param cancelButton storno button
 */
const infoDialog = (message, dispatch, onClose, cards = false, lang = null, cancelButton = true) => {
  const msg = getRenderableElement(message);

  return () => (
    <div>
      <FormBody cards={cards} fieldLabelPrefix={undefined} required={false}>{msg}</FormBody>
      <FormActions
        cancelButton={lang ? i18n(lang, "button_Close") : cancelButton}
        onClose={() => {
          dispatch(modal.ModalActions.hide());
          onClose && onClose();
        }}
        storeButton={false}
        disabled={false}
        submitButton={false}
        submitDisabled={false}
        onSubmit={() => {}}
        closeButton={false}
        createButton={false}
        okButton={false}
        children={null}
      />
    </div>
  );
};
